import React from "react";
import { useEffect, Fragment, useRef } from "react";

import Select from "react-select";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ezice from "./assets/ezice.png";
import { Dialog, Transition } from "@headlessui/react";
import ReactTooltip from "react-tooltip";
import ProgressHockeyStick from "./components/ProgressHockeyStick";
import { getRoot, classNames, daysAgo } from "./helpers";
import { clearSession, lookupOrder } from "./orderAccess";
import { useNavigate } from "react-router-dom";
import { DateTime } from "luxon";

import axios from "axios";

import { useState } from "react";
import {
  ChipIcon,
  CubeIcon,
  PuzzleIcon,
  ClipboardListIcon,
  ArrowsExpandIcon,
  LogoutIcon,
  MenuIcon,
  XIcon,
  PhoneIcon,
  MailIcon,
} from "@heroicons/react/outline";

export default function Portal() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarTab, setSidebarTab] = useState("Track Shipment");
  const [orderNumber, setOrderNumber] = useState(
    localStorage.getItem("eziceportal_orderNumber")
  );
  const [lastName, setLastName] = useState(
    localStorage.getItem("eziceportal_lastName")
  );
  const [trackingNumber, setTrackingNumber] = useState(null);

  const [order, setOrder] = useState(null);
  const [currentRinkOrder, setCurrentRinkOrder] = useState(null);
  const [currentRinkDescription, setCurrentRinkDescription] = useState(null);
  const [currentRinkSku, setCurrentRinkSku] = useState(null);

  const [orderHistory, setOrderHistory] = useState([]);
  const [rinkWidth, setRinkWidth] = useState(null);
  const [rinkLength, setRinkLength] = useState(null);
  const [rinkParts, setRinkParts] = useState(null);
  const [isOriginalRink, setIsOriginalRink] = useState(false);
  const [announcements, setAnnouncements] = useState([]);
  const [orderAnnouncements, setOrderAnnouncements] = useState([]);
  const [province, setProvince] = useState("");
  const [assemblies, setAssemblies] = useState([]);
  const [imageRinkDimensions, setImageRinkDimensions] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const navigate = useNavigate();
  const navigation = [
    { name: `${order?.cust_first_name}'s Rink`, href: "#", icon: ChipIcon },
    { name: "Track Shipment", href: "#", icon: CubeIcon },
    { name: "Assembly Instructions", href: "#", icon: PuzzleIcon },
    {
      name: "Previous Orders",
      href: "#",
      icon: ClipboardListIcon,
      current: false,
    },
    {
      name: "Upgrade Your Rink",
      href: "#",
      icon: ArrowsExpandIcon,
      callback: onUpgradeRinkSidebar,
    },
    { name: "Logout", href: "#", icon: LogoutIcon, callback: clearOrder },
  ];

  const [isDesktop, setDesktop] = useState(window.innerWidth > 1000);
  const updateMedia = () => {
    setDesktop(window.innerWidth > 1000);
  };
  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  useEffect(() => {
    if (orderNumber && lastName) {
      fetchOrder();
      fetchAnnouncements();
    } else {
      navigate("../", { replace: true });
    }
  }, []);

  useEffect(async () => {
    if (sidebarTab == "Assembly Instructions") {
      await fetchAssemblies();
    }
    if (sidebarTab == `${order?.cust_first_name}'s Rink` && order.cust_ref) {
      await fetchOrderHistory(order.cust_ref);
    }
  }, [sidebarTab]);
  //   useEffect(async () => {
  //     if (order == null) { return; }
  //
  //     const orderItems = order.order_items
  //
  //     orderItems.forEach(async item => {
  //       if (item.description.includes('WUP')) {
  //         const rinkSku = generateSkuFromUpgradeDescription(item.description)
  //
  //         if (rinkSku.includes('RINK')) {
  //           setupOriginalRink(item, rinkSku, order)
  //           return
  //         } else {
  //           await setupRink(item, order)
  //           return
  //         }
  //       }
  //
  //       if (item.description.includes('Home Arena System')) {
  //         await setupRink(item)
  //
  //         return
  //       }
  //     })
  //   }, [order]);

  async function fetchOrder() {
    let data;

    try {
      data = await lookupOrder(orderNumber, lastName);
    } catch (e) {
      toast.error("Incorrect Last Name or Order Number.");

      return;
    }

    setOrder(data);
    setTrackingNumber(data.tracking_number);
    setSidebarTab(`${data.cust_first_name}'s Rink`);
  }

  async function fetchAnnouncements() {
    const cleanedOrderNumber = orderNumber.replaceAll("#", "");
    const resp = await axios.get(
      `${getRoot()}/api/announcements?order_number=${cleanedOrderNumber}`
    );

    if (resp.data) {
      const announcements = resp.data.filter(
        (announcement) => !announcement.order_id
      );
      const orderAnnouncements = resp.data.filter(
        (announcement) => !!announcement.order_id
      );
      setAnnouncements(announcements);
      setOrderAnnouncements(orderAnnouncements);
    }
  }

  async function fetchAssemblies() {
    const resp = await axios.post(`${getRoot()}/api/assemblies/fetch`, {
      rink_skus: order.rink_skus,
    });

    if (resp.data) {
      setAssemblies(resp.data);
    }
  }

  async function fetchRink(sku) {
    const resp = await axios.get(
      `${getRoot()}/api/components/rink_parts?sku=${sku}`
    );

    if (resp.data) {
      setRinkParts(resp.data.parts);
    }
  }

  // the order comes from the access token, not from this argument
  async function fetchOrderHistory(order_number) {
    const resp = await axios.get(`${getRoot()}/api/orders/history`);
    const orders = resp.data;
    if (orders) {
      setOrderHistory(orders);
    }

    let foundItem = null;
    orders.forEach((order) => {
      if (!foundItem) {
        order.order_items.forEach((item) => {
          if (!foundItem) {
            if (item.description.includes("WUP")) {
              const rinkSku = generateSkuFromUpgradeDescription(
                item.description
              );

              if (rinkSku.includes("RINK")) {
                foundItem = item;
                return;
              } else {
                foundItem = item;
                return;
              }
            }

            if (item.description.includes("Home Arena System")) {
              foundItem = item;
              return;
            }

            if (order.rink_skus.length) {
              foundItem = item;
              return;
            }

            if (item.component.sku.includes("RINK")) {
              foundItem = item;
              return;
            }
          }
        });
      }
    });

    if (!foundItem) {
      return;
    }

    if (foundItem.description.includes("WUP")) {
      const rinkSku = generateSkuFromUpgradeDescription(foundItem.description);

      if (rinkSku.includes("RINK")) {
        setupOriginalRink(foundItem, rinkSku, order);
        return;
      } else {
        await setupProRink(null, rinkSku, order);
        return;
      }
    }

    if (foundItem.description.includes("Home Arena System")) {
      await setupProRink(
        foundItem,
        foundItem.description.split(" - ")[1],
        order
      );
      return;
    }

    if (order.rink_skus.length) {
      setupOriginalRink(foundItem, order.rink_skus[0], order);
      return;
    }

    if (foundItem.component.sku.includes("RINK")) {
      setupOriginalRink(foundItem, foundItem.component.sku, order);
      return;
    }
  }

  async function setupProRink(rinkOrderItem, rinkSku, order) {
    await fetchRink(rinkSku);

    const width = parseInt(rinkSku.substring(0, 3));
    const length = parseInt(rinkSku.substring(3, 6));
    const rinkSize = generateNearestRinkSize(width);

    if (rinkSize.width != width || rinkSize.length != length) {
      setImageRinkDimensions(rinkSize);
    }

    setCurrentRinkDescription(
      tryGeneratingRinkName(rinkSku) || rinkOrderItem.description
    );
    setCurrentRinkSku(rinkSku);
    setCurrentRinkOrder(order);
    setRinkWidth(width);
    setRinkLength(length);
  }

  async function fetchOrderBoms(custRef, idx) {
    const orderHistoryClone = JSON.parse(JSON.stringify(orderHistory));

    const order = orderHistoryClone[idx];

    if (order.isExpanded) {
      order.isExpanded = false;
      setOrderHistory(orderHistoryClone);
    } else {
      const cleanedOrderNumber = custRef.replaceAll("#", "");
      const parts = (
        await axios.get(`${getRoot()}/api/orders/${cleanedOrderNumber}/parts`)
      ).data.parts;

      order.parts = parts;
      order.isExpanded = true;

      setOrderHistory(orderHistoryClone);
    }
  }

  function generateIndexedUpgradeSkuFromDescription(description, index) {
    if (!description.includes(" to ")) {
      return null;
    }

    const skuArray = description.split("to")[index].split(" - ")[0].split("//");

    const width1 = skuArray[1].split("*")[0].split("ft")[0].trim();
    const length1 = skuArray[1].split("*")[1].split("ft")[0].trim();
    const paddedWidth1 = parseInt(width1) < 100 ? `0${width1}` : width1;
    const paddedLength1 = parseInt(length1) < 100 ? `0${length1}` : length1;
    const sides1 = skuArray[2]
      .split("-")
      .map((a) => a.trim()[0])
      .join("");
    const corner1 = skuArray[3].includes("Round Corners") ? "R" : "S";
    const bumper1 = skuArray[4].includes("With Bumpers") ? "B" : "X";

    return `${paddedWidth1}${paddedLength1}${sides1}${corner1}${bumper1}X`;
  }

  function tryGeneratingUpgradeRinkNames(title) {
    if (!title.includes(" to ")) {
      return null;
    }

    const fromRink = generateIndexedUpgradeSkuFromDescription(title, 0);
    const toRink = generateIndexedUpgradeSkuFromDescription(title, 1);

    return `Upgrade from ${tryGeneratingRinkName(
      fromRink
    )} to ${tryGeneratingRinkName(toRink)}`;
  }

  async function setupOriginalRink(rinkOrderItem, rinkSku, order) {
    setIsOriginalRink(true);

    await fetchRink(rinkSku);

    if (rinkOrderItem.description.includes("(+")) {
      setCurrentRinkDescription(rinkOrderItem.description.split("(+")[0]);
    } else {
      setCurrentRinkDescription(rinkOrderItem.description);
    }

    const width = parseInt(rinkSku.substring(2, 5));
    const length = parseInt(rinkSku.substring(6, 9));

    setCurrentRinkSku(
      order.rink_skus?.[0] ||
        order.order_items?.[0]?.component?.sku ||
        generateIndexedUpgradeSkuFromDescription(
          rinkOrderItem.description,
          1
        ) ||
        rinkSku
    );
    setCurrentRinkOrder(order);
    setRinkWidth(width);
    setRinkLength(length);
  }

  function clearOrder() {
    setOrder(null);
    setTrackingNumber("");
    clearSession();

    navigate("../", { replace: true });
  }

  function onSidebar(item, index) {
    if (item.callback) {
      return item.callback();
    }

    setSidebarTab(item.name);
    setActiveTabIndex(index);
    setSidebarOpen(false);
  }

  async function onUpgradeRinkSidebar() {
    // if (currentRinkSku) {
    //   window.open(`https://ezicerinks.com/pages/upgrade-rink?existing_rink_sku=${currentRinkSku}`, '_blank');
    // } else {
    window.open("https://ezicerinks.com/pages/upgrade-rink", "_blank");
    // }
  }

  function orgRinkSkuToProRinkSku(orgRinkSku) {
    if (!orgRinkSku) {
      return;
    }

    // Already PRO sku
    if (!orgRinkSku.includes("RINK")) {
      return orgRinkSku;
    }

    const width = orgRinkSku.substring(2, 5);
    const length = orgRinkSku.substring(6, 9);
    const corners = orgRinkSku.includes("RNDD") ? "R" : "S";

    return `${width}${length}CCC${corners}XX`;
  }

  function generateProRinkImageUrl(sku) {
    if (!sku) {
      return "";
    }

    const width = parseInt(sku.substring(0, 3));
    const length = parseInt(sku.substring(3, 6));
    const corners = sku.substring(9, 10);
    const bumpers = sku.substring(10, 11);
    const sides = sku.substring(6, 9);

    const rinkSize = generateNearestRinkSize(width);

    return `https://ezice.s3.amazonaws.com/rink-calc/imgc/${rinkSize.width}x${
      rinkSize.length
    }_${corners}_${bumpers == "B" ? "Y" : "N"}_Y_${generateImageStyle(
      sides
    )}.jpg`;
  }

  function generateOrderItemName(orderItem) {
    const maybeRinkName = tryGeneratingRinkName(orderItem.component?.sku);
    if (maybeRinkName) {
      return maybeRinkName;
    }

    const maybeUpgradeName = tryGeneratingUpgradeRinkNames(
      orderItem.description
    );
    if (maybeUpgradeName) {
      return maybeUpgradeName;
    }

    return orderItem.description;
  }

  function tryGeneratingRinkName(sku) {
    if (!sku) {
      return null;
    }

    const width = parseInt(sku.substring(0, 3));
    const length = parseInt(sku.substring(3, 6));
    const corners = sku.substring(9, 10);
    const bumpers = sku.substring(10, 11);
    const sides = sku.substring(6, 9);

    let sideNaming;
    if (sides == "CCC") {
      sideNaming = "Classic Height";
    } else if (sides == "DDD") {
      sideNaming = "Double Height";
    } else if (sides == "AAA") {
      sideNaming = "Arena Height";
    } else if (sides == "NNN") {
      sideNaming = "Arena Height plus Netting";
    } else if (sides == "NCN") {
      sideNaming = "Classic Height plus Arena/Netting Ends";
    } else if (sides == "ACA") {
      sideNaming = "Classic Height plus Arena Ends";
    } else if (sides == "DCD") {
      sideNaming = "Classic Height plus Double Ends";
    } else if (sides == "ADA") {
      sideNaming = "Double Height plus Arena Ends";
    } else if (sides == "NDN") {
      sideNaming = "Double Height plus Arena/Netting Ends";
    } else if (sides == "CCN") {
      sideNaming = "Classic Height plus One Arena/Netting End";
    } else if (sides == "CCA") {
      sideNaming = "Classic Height plus One Arena End";
    } else if (sides == "CCD") {
      sideNaming = "Classic Height plus One Double End";
    } else if (sides == "DDA") {
      sideNaming = "Double Height plus One Arena End";
    } else if (sides == "DDN") {
      sideNaming = "Double Height plus One Arena/Netting End";
    } else if (sides == "NCC") {
      sideNaming = "Classic Height plus One Arena/Netting End";
    } else if (sides == "ACC") {
      sideNaming = "Classic Height plus One Arena End";
    } else if (sides == "DCC") {
      sideNaming = "Classic Height plus One Double End";
    } else if (sides == "ADD") {
      sideNaming = "Double Height plus One Arena End";
    } else if (sides == "NDD") {
      sideNaming = "Double Height plus One Arena/Netting End";
    } else if (sides == "NAN") {
      sideNaming = "Arena Height plus Arena/Netting Ends";
    } else if (sides == "AAN") {
      sideNaming = "Arena Height plus One Arena/Netting End";
    } else if (sides == "NAA") {
      sideNaming = "Arena Height plus One Arena/Netting End";
    } else if (sides == "DCA") {
      sideNaming = "Classic Height plus Arena End, Double End";
    } else if (sides == "DCN") {
      sideNaming = "Classic Height plus Arena/Netting End, Double End";
    } else if (sides == "ACN") {
      sideNaming = "Classic Height plus Arena/Netting End, Arena End";
    } else if (sides == "ACD") {
      sideNaming = "Classic Height plus Arena End, Double End";
    } else if (sides == "NCD") {
      sideNaming = "Classic Height plus Arena/Netting End, Double End";
    } else if (sides == "NCA") {
      sideNaming = "Classic Height plus Arena/Netting End, Arena End";
    } else if (sides == "NDA") {
      sideNaming = "Double Height plus Arena/Netting End, Arena End";
    } else if (sides == "ADN") {
      sideNaming = "Double Height plus Arena/Netting End, Arena End";
    }

    if (!sideNaming) {
      return null;
    }

    return `${width} x ${length} ${sideNaming} with ${
      corners === "S" ? "Square" : "Round"
    } Corners${bumpers === "B" ? " and Bumpers" : ""}`;
  }

  function generateNearestRinkSize(width) {
    if (width >= 10 && width <= 15) {
      return { width: 15, length: 30 };
    } else if (width > 15 && width <= 20) {
      return { width: 20, length: 40 };
    } else if (width > 20 && width <= 25) {
      return { width: 25, length: 50 };
    } else if (width > 25 && width <= 30) {
      return { width: 30, length: 60 };
    } else if (width > 30 && width <= 40) {
      return { width: 40, length: 80 };
    } else if (width > 40 && width <= 60) {
      return { width: 60, length: 100 };
    } else if (width > 60 && width <= 80) {
      return { width: 80, length: 120 };
    } else if (width > 80) {
      return { width: 85, length: 200 };
    }
  }

  function generateImageStyle(styleString) {
    let style;
    if (styleString == "CCC") {
      style = "01";
    } else if (styleString == "DDD") {
      style = "02";
    } else if (styleString == "AAA") {
      style = "03";
    } else if (styleString == "NNN") {
      style = "04";
    } else if (styleString == "NCN") {
      style = "05";
    } else if (styleString == "ACA") {
      style = "06";
    } else if (styleString == "DCD") {
      style = "07";
    } else if (styleString == "ADA") {
      style = "08";
    } else if (styleString == "NDN") {
      style = "09";
    } else if (styleString == "CCN") {
      style = "10";
    } else if (styleString == "CCA") {
      style = "11";
    } else if (styleString == "CCD") {
      style = "12";
    } else if (styleString == "DDA") {
      style = "13";
    } else if (styleString == "DDN") {
      style = "14";
    } else if (styleString == "NCC") {
      style = "15";
    } else if (styleString == "ACC") {
      style = "16";
    } else if (styleString == "DCC") {
      style = "17";
    } else if (styleString == "ADD") {
      style = "18";
    } else if (styleString == "NDD") {
      style = "19";
    } else if (styleString == "NAN") {
      style = "20";
    } else if (styleString == "AAN") {
      style = "21";
    } else if (styleString == "NAA") {
      style = "22";
    } else if (styleString == "DCA") {
      style = "23";
    } else if (styleString == "DCN") {
      style = "24";
    } else if (styleString == "ACN") {
      style = "25";
    } else if (styleString == "ACD") {
      style = "26";
    } else if (styleString == "NCD") {
      style = "27";
    } else if (styleString == "NCA") {
      style = "28";
    } else if (styleString == "NDA") {
      style = "29";
    } else if (styleString == "ADN") {
      style = "30";
    }

    return style;
  }

  function isLastRinkOrUpgrade(cust_ref) {
    orderHistory.forEach((pastOrder) => {
      pastOrder.order_items.forEach((item) => {
        if (item.description.includes("Home Arena System")) {
          if (pastOrder.cust_ref == cust_ref) {
            return true;
          } else {
            return false;
          }
        }
      });
    });
  }

  // 'upgrade', rink', 'liner', 'other'
  function orderType(order) {
    let orderItemType = null;

    order.order_items.forEach((item) => {
      if (item.description.includes("WUP")) {
        orderItemType = "upgrade";
        return;
      }
    });

    if (orderItemType) {
      return orderItemType;
    }

    order.order_items.forEach((item) => {
      if (item.description.includes("Home Arena System")) {
        orderItemType = "rink";
        return;
      }
    });

    if (orderItemType) {
      return orderItemType;
    }

    order.order_items.forEach((item) => {
      if (
        item.description.includes("Liner") &&
        !item.description.includes("Clips")
      ) {
        orderItemType = "liner";
        return;
      }
    });

    if (orderItemType) {
      return orderItemType;
    }

    return "other";
  }

  function generatePartImage(sku) {
    if (sku.includes("STRAP")) {
      sku = "STRAP";
    }

    if (sku.includes("TSHIRT")) {
      sku = "TSHIRT";
    }

    if (sku.includes("LINR")) {
      sku = "LINER";
    }

    return `https://ezice.s3.amazonaws.com/portal/parts/${sku}.jpeg`;
  }

  function generatePartName(sku) {
    if (sku.includes("LINR")) {
      return `${parseInt(sku.substring(2, 5))}' x ${parseInt(
        sku.substring(6, 9)
      )}' Rink Liner`;
    }

    if (sku.includes("FOOTSTRAP")) {
      return `${sku.split("FOOTSTRAP")[0]}' Strap`;
    }

    if (sku.includes("LINERCLIP")) {
      return "Liner Clips (10 Pack)";
    }

    return sku;
  }

  function generateProRinkAssemblyLink() {
    const sides = currentRinkSku.substring(6, 9);
    const corners = currentRinkSku.substring(9, 10) == "S" ? "Square" : "Round";

    let highestSide;
    if (sides.includes("N")) {
      highestSide = "Netting";
    } else if (sides.includes("A") || sides.includes("D")) {
      highestSide = "Arena";
    } else {
      highestSide = "Classic";
    }

    return assemblies.find((assembly) => {
      return assembly.filename.includes(`${highestSide} ${corners}`);
    });
  }

  function generateSkuFromUpgradeDescription(upgradeDescription) {
    const descArr = upgradeDescription.split("] to [")[1].split("//");
    const uncleansedDimensions = descArr[1].trim().split("*");

    const rinkType = descArr[0].trim();
    const width = uncleansedDimensions[0].split("ft")[0].trim();
    const paddedWidth = parseInt(width) < 100 ? `0${width}` : width;
    const length = uncleansedDimensions[1].split("ft")[0].trim();
    const paddedLength = parseInt(length) < 100 ? `0${length}` : length;
    const sides = descArr[2]
      .trim()
      .split("-")
      .map((side) => side[0])
      .join("");
    const corner = descArr[3].includes("Round") ? "R" : "S";
    const bumper = descArr[4].includes("No") ? "X" : "B";

    if (rinkType == "PRO") {
      return `${paddedWidth}${paddedLength}${sides}${corner}${bumper}X`;
    } else {
      const orgCorner = corner == "R" ? "RNDD" : "NONE";
      return `EZ${paddedWidth}X${paddedLength}RINK000X000${orgCorner}`;
    }
  }

  function subrenderCurrentRink() {
    return (
      <div>
        {currentRinkDescription ? (
          <div className="flex flex-col items-center relative">
            {isOriginalRink ? (
              <div className="flex flex-col items-center">
                {tryGeneratingRinkName(orgRinkSkuToProRinkSku(currentRinkSku))}
                {currentRinkSku && (
                  <img
                    width="500"
                    className="mt-4  rounded-md border-ezice"
                    src={generateProRinkImageUrl(
                      orgRinkSkuToProRinkSku(currentRinkSku)
                    )}
                  />
                )}
              </div>
            ) : (
              <div className="flex flex-col items-center">
                <div>{tryGeneratingRinkName(currentRinkSku)}</div>
                <img
                  width="500"
                  className="mt-4  rounded-md border-ezice"
                  src={generateProRinkImageUrl(currentRinkSku)}
                />
                {imageRinkDimensions && (
                  <div className="text-xs text-gray-600 absolute bottom-1">
                    ({imageRinkDimensions.width}x{imageRinkDimensions.length}{" "}
                    shown)
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <div>
            No rinks were found associated with your Order Number. Visit{" "}
            <a href="https://ezicerinks.com/?features=#shoprinks">
              our rink page
            </a>{" "}
            to order yours today!
          </div>
        )}
      </div>
    );
  }

  function subrenderPreviousOrders() {
    return (
      <Fragment>
        {orderHistory.length && (
          <div className="flex flex-col justify-left w-full mt-4 hover:cursor-pointer">
            {orderHistory.map((pastOrder, idx) => (
              <div className="flex flex-col border-gray-300 border-b">
                <div
                  className={classNames(
                    isLastRinkOrUpgrade(pastOrder.cust_ref) ? "bg-yellow" : "",
                    "flex space-x-2 items-center align-center pt-2 pb-2"
                  )}
                  onClick={() => fetchOrderBoms(pastOrder.cust_ref, idx)}
                >
                  {isDesktop ? (
                    <div className="basis-2/12">
                      {orderType(pastOrder) == "rink" && (
                        <img
                          width="100"
                          className=" rounded-md border-ezice h-16 w-24"
                          src={generateProRinkImageUrl(
                            pastOrder.order_items[0].component.sku
                          )}
                        />
                      )}

                      {orderType(pastOrder) == "upgrade" && (
                        <img
                          width="100"
                          className=" rounded-md border-ezice h-16 w-24"
                          src={generateProRinkImageUrl(
                            orgRinkSkuToProRinkSku(
                              generateIndexedUpgradeSkuFromDescription(
                                pastOrder.wup_description,
                                1
                              )
                            )
                          )}
                        />
                      )}

                      {orderType(pastOrder) == "liner" && (
                        <img
                          className=" rounded-md border-ezice h-16 w-24"
                          src="https://ezice.s3.amazonaws.com/upgrade-calc/img/liner.png"
                        />
                      )}

                      {orderType(pastOrder) == "other" && (
                        <img
                          className=" rounded-md border-ezice h-16 w-24"
                          src={ezice}
                        />
                      )}
                    </div>
                  ) : (
                    <div></div>
                  )}

                  <div className="basis-1/12">
                    {isDesktop ? (
                      <div className="text-sm text-gray-600">
                        {DateTime.fromISO(pastOrder.created_at).toFormat(
                          "MMMM dd, yyyy"
                        )}
                      </div>
                    ) : (
                      <div className="text-sm text-gray-600">
                        {DateTime.fromISO(pastOrder.created_at).toFormat(
                          "MM/dd/yy"
                        )}
                      </div>
                    )}
                  </div>

                  <div className="basis-1/12">
                    <div className="text-sm text-gray-600">
                      {pastOrder.cust_ref}
                    </div>
                  </div>

                  <div className="basis-8/12">
                    {pastOrder.order_items?.map((order_item, idx) => {
                      return (
                        <div className="text-sm text-gray-600">
                          {order_item.quantity > 1
                            ? `${order_item.quantity} x `
                            : ""}
                          {generateOrderItemName(order_item)}
                        </div>
                      );
                    })}
                  </div>
                  <div className="flex align-center justify-center flex-shrink-0 whitespace-nowrap text-sm text-gray-500"></div>
                </div>
                {pastOrder.isExpanded && pastOrder.parts.length > 0 && (
                  <ul className="mt-2 ml-8">
                    {pastOrder.parts?.map((part) => (
                      <li className="text-xs text-gray-600 list-disc">
                        {part.quantity} x {part.name || part.sku}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        )}
      </Fragment>
    );
  }

  function renderRink() {
    return (
      <Fragment>
        <h1
          className="text-2xl mb-4 font-semibold text-gray-900"
          data-test="rinkname"
        >
          {order?.cust_first_name}'s Rink
        </h1>

        {subrenderCurrentRink()}

        <h5 className="mt-12 font-semibold text-gray-900 mb-4">
          Your Rink Components
        </h5>

        <div className="flex flex-wrap mb-5 justify-center">
          {rinkParts &&
            rinkParts.map((part, idx) => {
              return (
                <div className="flex w-1/5 mx-4 flex-col items-center">
                  <div className="flex flex-col justify-center">
                    <img
                      className=" rounded-md border-ezice"
                      src={generatePartImage(part.sku)}
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src =
                          "https://ezice.s3.amazonaws.com/portal/parts/ezice.png";
                      }}
                    />
                  </div>

                  <div className="text-sm text-gray-600 pb-2 bk3:text-xs">
                    {part.quantity > 1 && <span>{part.quantity} x </span>}

                    <b>{part.name || generatePartName(part.sku)}</b>
                  </div>
                </div>
              );
            })}
        </div>

        {/* <h5 className="mb-0 mt-12">Previous Orders</h5>
        {subrenderPreviousOrders()} */}
      </Fragment>
    );
  }

  function renderTrackShipment() {
    return (
      <Fragment>
        <h1 className="text-2xl mb-4 font-semibold text-gray-900">
          Track Shipment
        </h1>

        <div className="flex flex-column">
          <ul className="divide-y divide-gray-200">
            {announcements.map((announcement) => (
              <li
                key={announcement.id}
                className="relative bg-ezice-yellow-600 p-2"
              >
                <div className="flex space-x-3 justify-between align-center">
                  <div className="mt-1">
                    <p className="text-sm mb-1 text-gray-600">
                      {announcement.message}
                    </p>
                  </div>
                  <div className="flex align-center justify-center flex-shrink-0 whitespace-nowrap text-sm text-gray-500">
                    <time dateTime={announcement.created_at}>
                      {`${Math.round(
                        daysAgo(announcement.created_at)
                      )} days ago`}
                    </time>
                  </div>
                </div>
              </li>
            ))}
          </ul>
          <br />

          <a
            className="text-underline cursor-pointer w-max"
            onClick={clearOrder}
          >
            Look up different order
          </a>
        </div>

        <div>
          {order.warehouse_status.name == "Delivered" && (
            <Fragment>
              <div className="mt-4">
                Hi {order.cust_first_name} {order.cust_last_name}, You do not
                have any active orders.{" "}
                <a
                  className="cursor-pointer"
                  onClick={() => onUpgradeRinkSidebar()}
                >
                  Upgrade
                </a>{" "}
                your {rinkWidth ? `${rinkWidth}x${rinkLength}` : ""} rink now.
              </div>
              <div className="flex flex-col mt-4">
                <div className="mb-4">
                  Current orders are shipping in 1 to 20 business days. Please
                  enter your location for an estimated shipping time.
                </div>
                <Select
                  className="cursor-pointer w-36 portal-input-override"
                  options={PROVINCES}
                  onChange={(provinceObj) => setProvince(provinceObj)}
                  value={province}
                  width="144px"
                  height="38px"
                />

                {province && (
                  <Fragment>
                    <div className="mt-4">
                      {province.value}: {DELIVERY_TIMES[province.value]?.min} to{" "}
                      {DELIVERY_TIMES[province.value]?.max} business days to
                      arrive.
                    </div>
                    <div>
                      * Please note that these are estimated timeframes. Once
                      your order is placed, we will be able to provide a more
                      accurate shipping and delivery window.
                    </div>
                  </Fragment>
                )}
              </div>
            </Fragment>
          )}

          {order.warehouse_status.name != "Delivered" && (
            <Fragment>
              <div className="mt-4">
                Hi {order.cust_first_name} {order.cust_last_name}, you have 1
                current active order.
              </div>
            </Fragment>
          )}

          <div className="flex justify-between p-4 mt-4  rounded-md border-ezice-blue-700 bk1:flex-col bk1:items-center">
            <div className="flex flex-col bk1:items-center">
              <div className="font-bold">Order {order.cust_ref}</div>

              <ProgressHockeyStick order={order} />

              <div className="mb-4 mt-8 flex flex-column  border-rose-700 rounded-md p-2">
                <div className="font-bold">Delivery Information</div>

                {!order.carrier ||
                  ((order.warehouse_status.name === "Shipped / On Truck" ||
                    order.warehouse_status.name === "Delivered") && (
                    <li className="text-sm">
                      Delivery information will be available once your rink
                      ships.
                    </li>
                  ))}

                {order.carrier && order.projected_ship_date && (
                  <li className="text-sm">
                    Projected Ship Date: {order.projected_ship_date}
                  </li>
                )}

                {order.carrier && (
                  <li className="text-sm">
                    Carrier:{" "}
                    <a href={order.carrier.url} target="_blank">
                      {order.carrier.name}
                    </a>{" "}
                    ({order.carrier.phone})
                  </li>
                )}

                {order.carrier && order.tracking_number && (
                  <li className="text-sm">
                    Tracking Number: {order.tracking_number}
                  </li>
                )}
              </div>
            </div>
            <div className="flex flex-col bk1:mt-4 max-w-sm min-w-sm">
              <div className="flex flex-col mb-4 flex  border-rose-700 rounded-md p-2">
                <div className="font-bold">Order Details</div>
                <ul>
                  {order.order_items?.map((order_item, idx) => {
                    return (
                      <li className="text-sm">
                        {order_item.quantity} x {order_item.description}
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="mb-4 flex flex-col  border-rose-700 rounded-md p-2">
                <div className="font-bold">Order Updates</div>
                <ul className="divide-y divide-gray-200">
                  {orderAnnouncements.map((announcement) => (
                    <li key={announcement.id} className="relative p-2">
                      <div className="flex space-x-3 justify-between align-center">
                        <div className="">
                          <p className="text-sm mb-1 text-gray-600">
                            {announcement.message}
                          </p>
                        </div>
                        <div className="flex align-center justify-center flex-shrink-0 whitespace-nowrap text-sm text-gray-500">
                          <time dateTime={announcement.created_at}>
                            {`${Math.round(
                              daysAgo(announcement.created_at)
                            )} days ago`}
                          </time>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  function renderAssemblyInstructions() {
    return (
      <Fragment>
        <h1 className="text-2xl mb-4 font-semibold text-gray-900">
          Assembly Instructions
        </h1>

        {true ? (
          <Fragment>
            {subrenderCurrentRink()}

            <div className="flex justify-center font-medium mt-4">
              <button className="flex inline-block p-3 border rounded-full border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-ezice-blue-600 hover:bg-ezice-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ezice-blue-500">
                <a
                  className="text-white"
                  target="_blank"
                  href={`https://ezice.s3.amazonaws.com/${
                    generateProRinkAssemblyLink()?.s3_object
                  }`}
                >
                  Click here for Assembly Instructions for your rink
                </a>
              </button>
            </div>

            <div className="flex flex-col justify-center items-center">
              <div className="flex text-xs mt-8 justify-center font-bold text-base">
                Assembly questions? Ask our Backyard Rink Experts!
              </div>
              <div className="flex justify-center items-center font-bold">
                <div className="flex justify-center items-center w-12 bg-ezice-blue-600 mt-2 mr-2 rounded-full">
                  <PhoneIcon
                    className="h-12 w-8 text-white"
                    aria-hidden="true"
                  />
                </div>
                (262) 394-2360
              </div>
              <div className="flex justify-center items-center font-bold ml-14">
                <div className="flex justify-center items-center w-12 bg-ezice-blue-600 mt-2 mr-2 rounded-full">
                  <MailIcon
                    className="h-12 w-8 text-white"
                    aria-hidden="true"
                  />
                </div>
                expert@ezicerinks.com
              </div>
            </div>

            {/* <h5 className="mt-12 font-semibold text-gray-900 mb-4">
              Your Rink Components
            </h5>

            <div className="flex flex-wrap mb-5">
              {rinkParts &&
                rinkParts.map((part, idx) => {
                  return (
                    <div className="flex w-1/5 mx-4 flex-col items-center">
                      <div className="flex flex-col justify-center">
                        <img
                          className=" rounded-md border-ezice"
                          src={generatePartImage(part.sku)}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null;
                            currentTarget.src =
                              "https://ezice.s3.amazonaws.com/portal/parts/ezice.png";
                          }}
                        />
                      </div>

                      <div className="text-sm text-gray-600 pb-2 bk3:text-xs">
                        {part.quantity > 1 && <span>{part.quantity} x </span>}

                        <b>{part.name || generatePartName(part.sku)}</b>
                      </div>
                    </div>
                  );
                })}
            </div> */}
          </Fragment>
        ) : (
          <Fragment>
            <div className="flex flex-column justify-center font-medium mt-4">
              {ASSEMBLIES.map((assembly) => {
                return (
                  <div className="flex flex-column mt-5 items-center">
                    <a
                      className="text-sm cursor-pointer mt-1"
                      href={`https://ezice.s3.amazonaws.com/${assembly.s3_object}`}
                    >
                      <img
                        src={`https://ezice.s3.amazonaws.com/${assembly.s3_object_img}`}
                        width="200"
                        alt=""
                      />
                    </a>
                    <a
                      className="text-sm cursor-pointer mt-1"
                      href={`https://ezice.s3.amazonaws.com/${assembly.s3_object}`}
                    >
                      {assembly.filename}
                    </a>
                  </div>
                );
              })}
            </div>

            <div className="flex text-xs mt-4 justify-center">
              Have assembly questions? Ask our Backyard Rink Experts at (262)
              394-2360 or expert@ezicerinks.com
            </div>
          </Fragment>
        )}
      </Fragment>
    );
  }

  function renderPreviousOrders() {
    return (
      <Fragment>
        <h1 className="text-2xl mb-4 font-semibold text-gray-900">
          Previous Orders
        </h1>

        {subrenderPreviousOrders()}
      </Fragment>
    );
  }

  return (
    <div className="h-screen flex overflow-hidden">
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          static
          className="fixed inset-0 flex z-40 md:hidden"
          open={sidebarOpen}
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-300 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-300 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full"
          >
            <div className="relative flex-1 flex flex-col max-w-xs w-full bg-ezice-blue-700">
              <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="absolute top-0 right-0 -mr-12 pt-2">
                  <button
                    className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                    onClick={() => setSidebarOpen(false)}
                  >
                    <span className="sr-only">Close sidebar</span>
                    <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                  </button>
                </div>
              </Transition.Child>
              <div className="flex-1 h-0 pb-4 overflow-y-auto">
                <div className="mt-4 flex items-center flex-shrink-0 px-4 text-white font-bold">
                  EZ ICE Customer Portal
                </div>
                <nav className="mt-4 px-2 space-y-1">
                  {navigation.map((item, index) => (
                    <a
                      key={item.name}
                      href={item.href}
                      className={classNames(
                        item.current
                          ? "bg-ezice-blue-800 text-white"
                          : "text-gray-300 hover:bg-ezice-blue-700 hover:text-white",
                        "group flex items-center px-2 py-2 text-base font-medium rounded-md"
                      )}
                      onClick={() => onSidebar(item, index)}
                    >
                      <item.icon
                        className={classNames(
                          item.current
                            ? "text-gray-300"
                            : "text-gray-400 group-hover:text-gray-300",
                          "mr-4 flex-shrink-0 h-6 w-6"
                        )}
                        aria-hidden="true"
                      />
                      {item.name}
                    </a>
                  ))}
                </nav>
              </div>
              {/*}
              <div className="flex-shrink-0 flex bg-ezice-blue-700 p-4">
                <a href="#" className="flex-shrink-0 group block">
                  <div className="flex items-center">
                    <div>
                      <img
                        className="inline-block h-10 w-10 rounded-full"
                        src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                        alt=""
                      />
                    </div>
                    <div className="ml-3">
                      <p className="text-base font-medium text-white">Tom Cook</p>
                      <p className="text-sm font-medium text-gray-400 group-hover:text-gray-300">View profile</p>
                    </div>
                  </div>
                </a>
              </div>
            */}
            </div>
          </Transition.Child>
          <div className="flex-shrink-0 w-14">
            {/* Force sidebar to shrink to fit close icon */}
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div className="hidden md:flex md:flex-shrink-0">
        <div className="flex flex-col w-64">
          <div className="flex flex-col h-0 flex-1 bg-ezice-blue-700">
            <div className="flex-1 flex flex-col pb-4 overflow-y-auto">
              <div className="mt-4 flex items-center flex-shrink-0 px-4 text-white font-bold">
                EZ ICE Customer Portal
              </div>

              <nav className="mt-4 flex-1 px-2 bg-ezice-blue-700 space-y-1">
                {navigation.map((item, index) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className={classNames(
                      index === activeTabIndex
                        ? "bg-ezice-blue-800 text-white"
                        : "text-gray-300 hover:bg-ezice-blue-700 hover:text-white",
                      "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                    )}
                    onClick={() => onSidebar(item, index)}
                  >
                    <item.icon
                      className={classNames(
                        index === activeTabIndex
                          ? "text-gray-300"
                          : "text-gray-400 group-hover:text-gray-300",
                        "mr-3 flex-shrink-0 h-6 w-6"
                      )}
                      aria-hidden="true"
                    />
                    {item.name}
                  </a>
                ))}
              </nav>
            </div>
            {/* <div className="flex-shrink-0 flex bg-ezice-blue-700 p-4">
              <a href="#" className="flex-shrink-0 w-full group block">
                <div className="flex items-center">
                  <div>
                    <img
                      className="inline-block h-9 w-9 rounded-full"
                      src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                      alt=""
                    />
                  </div>
                  <div className="ml-3">
                    <p className="text-sm font-medium text-white">Tom Cook</p>
                    <p className="text-xs font-medium text-gray-300 group-hover:text-gray-200">View profile</p>
                  </div>
                </div>
              </a>
            </div> */}
          </div>
        </div>
      </div>
      <div className="flex flex-col w-0 flex-1 overflow-hidden">
        <div className="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3">
          <button
            className="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <MenuIcon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <main className="flex-1 relative z-0 overflow-y-auto focus:outline-none">
          <div className="py-6">
            {order && (
              <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 bk2:mb-8">
                {sidebarTab == `${order?.cust_first_name}'s Rink` &&
                  renderRink()}

                {sidebarTab == "Track Shipment" && renderTrackShipment()}

                {sidebarTab == "Assembly Instructions" &&
                  renderAssemblyInstructions()}

                {sidebarTab == "Previous Orders" && renderPreviousOrders()}
              </div>
            )}
          </div>
        </main>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <ReactTooltip place="bottom" />
    </div>
  );
}

const ASSEMBLIES = [
  {
    s3_object: "portal/assemblies/PDF+Arena_Round_Netting.pdf",
    s3_object_img: "portal/assemblies/Arena_Round_Netting.png",
    filename: "Netting Round Rink Assembly Guide",
  },
  {
    s3_object: "portal/assemblies/PDF+Arena_Square_Netting.pdf",
    s3_object_img: "portal/assemblies/Arena_Square_Netting.png",
    filename: "Netting Square Rink Assembly Guide",
  },
  {
    s3_object: "portal/assemblies/PDF+Arena_Round.pdf",
    s3_object_img: "portal/assemblies/Arena_Round.png",
    filename: "Arena Round Rink Assembly Guide",
  },
  {
    s3_object: "portal/assemblies/PDF+Arena_Square.pdf",
    s3_object_img: "portal/assemblies/Arena_Square.png",
    filename: "Arena Square Rink Assembly Guide",
  },
  {
    s3_object: "portal/assemblies/PDF+Classic_Round.pdf",
    s3_object_img: "portal/assemblies/Classic_Round.png",
    filename: "Classic Round Rink Assembly Guide",
  },
  {
    s3_object: "portal/assemblies/PDF+Classic_Square.pdf",
    s3_object_img: "portal/assemblies/Classic_Square.png",
    filename: "Classic Square Rink Assembly Guide",
  },
];

const DELIVERY_TIMES = {
  AB: { min: 5, max: 5 },
  AK: { min: 5, max: 10 },
  AZ: { min: 5, max: 10 },
  BC: { min: 5, max: 10 },
  CA: { min: 5, max: 5 },
  CO: { min: 5, max: 5 },
  CT: { min: 1, max: 1 },
  IA: { min: 1, max: 2 },
  ID: { min: 5, max: 10 },
  IL: { min: 1, max: 2 },
  IN: { min: 1, max: 2 },
  KS: { min: 1, max: 5 },
  MA: { min: 1, max: 1 },
  MB: { min: 1, max: 5 },
  MD: { min: 1, max: 5 },
  ME: { min: 1, max: 5 },
  MI: { min: 1, max: 2 },
  MN: { min: 1, max: 2 },
  MO: { min: 1, max: 2 },
  MT: { min: 5, max: 10 },
  NB: { min: 1, max: 5 },
  ND: { min: 1, max: 5 },
  NE: { min: 1, max: 5 },
  NH: { min: 1, max: 2 },
  NJ: { min: 1, max: 2 },
  NL: { min: 5, max: 10 },
  NS: { min: 5, max: 10 },
  NT: { min: 10, max: 15 },
  NY: { min: 1, max: 2 },
  OH: { min: 1, max: 2 },
  ON: { min: 3, max: 4 },
  PA: { min: 2, max: 3 },
  PE: { min: 5, max: 5 },
  QC: { min: 5, max: 5 },
  RI: { min: 1, max: 1 },
  SD: { min: 2, max: 3 },
  SK: { min: 5, max: 5 },
  UT: { min: 5, max: 5 },
  VA: { min: 2, max: 3 },
  VT: { min: 1, max: 5 },
  WA: { min: 5, max: 10 },
  WI: { min: 1, max: 2 },
  WY: { min: 5, max: 10 },
  YT: { min: 10, max: 15 },
};

const PROVINCES = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Alberta", value: "AB" },
  { label: "American Samoa", value: "AS" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "Armed Forces (AE)", value: "AE" },
  { label: "Armed Forces Americas", value: "AA" },
  { label: "Armed Forces Pacific", value: "AP" },
  { label: "British Columbia", value: "BC" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "District Of Columbia", value: "DC" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Guam", value: "GU" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Manitoba", value: "MB" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Brunswick", value: "NB" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "Newfoundland", value: "NF" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Northwest Territories", value: "NT" },
  { label: "Nova Scotia", value: "NS" },
  { label: "Nunavut", value: "NU" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Ontario", value: "ON" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Prince Edward Island", value: "PE" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Quebec", value: "PQ" },
  { label: "Rhode Island", value: "RI" },
  { label: "Saskatchewan", value: "SK" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virgin Islands", value: "VI" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
  { label: "Yukon Territory", value: "YT" },
];
